import * as React from "react";
import styles from "./whatsIncluded.module.scss";
import Button from "../../../../components/button";
import DotGrid from "../../../../components/dot-grid";
import PaymentSeals from "../../../../components/payment-seals";

const Img = "https://res.cloudinary.com/albin-groen/image/upload/f_auto/v1586101021/ceroface/whats-included.png"

const WhatsIncluded = () => {
  return (
    <div className={styles.whatsIncluded}>
      <DotGrid size={25} className={styles.dotGrid} />
      <div className={styles.whatsIncludedContent}>
        <div className={styles.text}>
          <h1>What's in the box?</h1>

          <img
            className={styles.smallImage}
            src={Img}
            alt="What is in the box"
          />

          <ul>
            <li>
              CeroFace Device - Leaves your skin feeling{" "}
              <strong>baby smooth</strong>.
            </li>
            <li>
              Customized heads - Find out your <strong>favorite</strong>.
            </li>
            <li>
              USB Charger - Charge your device <strong>easily</strong>.
            </li>
            <li>
              User guide - <strong>Easy to follow</strong> and guides you step
              by step.
            </li>
            <li>
              Lifetime warranty - With us, you're always{" "}
              <strong>fully guaranteed</strong>.
            </li>
          </ul>

          <div className={styles.ctaWrapper}>
            <Button variant="cta" href="/cart">
              RUSH MY ORDER
            </Button>

            <PaymentSeals />
          </div>
        </div>
      </div>

      <img
        className={styles.largeImage}
        src={Img}
        alt="What is in the box"
      />
    </div>
  );
};

export default WhatsIncluded;
